module.exports = __webpack_public_path__ + "media/images/products/wedding/img-compensation-case2-760a49afeef0f553e8174c274c04d5f0.png";